import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-social-facebook',
  templateUrl: './icon-social-facebook.component.html',
  styleUrls: ['./icon-social-facebook.component.scss']
})
export class IconSocialFacebookComponent implements OnInit {
  @Input() size = 40;
  
  constructor() { }

  ngOnInit() {
  }

}
